export enum TrackingLabel {
  PAYPAL_CLICKED = 'PayLater Learn More',
}

export enum TrackingCategory {
  PRODUCT_PAGE = 'Product Page',
}

export interface PaypalClickedEventPayload {
  category: TrackingCategory;
  label: TrackingLabel;
  eventDetail: string;
  navigationDetail: string;
  trackingTenant: string;
  product_id: string;
  paypalMessageVariant: string;
  core_product_id: string;
}

export interface EventInformation {
  eventDetail: string;
  navigationDetail: string;
  label: TrackingLabel;
}
